import { Box, Button, Circle, IconButton, Image, Menu, MenuButton, MenuItem, MenuList, Text, Tooltip, Link } from "@chakra-ui/react";
import { ReactComponent as ContextMenuIcon } from '../../svg/ContextMenu.svg'

export default function IndividualLiveCourseCard({ image, name, start_time, trainer_name, duration, id, link }) {
    return (
        <Box
            d='flex'
            width='100%'
            bg='white'
            borderRadius='2xl'
            my='1rem'
            p='1rem'
            justifyContent={['center', 'center', 'center', 'space-between']}
            alignItems={['flex-start', 'flex-start', 'flex-start', 'center']}
            flexDirection={['column', 'column', 'column', 'row']}
            _hover={{ boxShadow: 'xl' }}
            position='relative'
        >
            <Box
                d='flex'
                width={['100%', '100%', '100%', '25%']}
                flexDir={['column', 'column', 'column', 'row']}
                mb={['3rem', '3rem', '3rem', '0']}
            >
                <Image src={image} width='60px' height='60px' fallbackSrc="https://source.unsplash.com/random/800x600" objectFit='cover' d={['none', 'none', 'none', 'flex']} borderRadius='50%' mr='2' />
                <Box d='flex' flexDir='column' alignItems='flex-start' justifyContent='center'>
                    <Tooltip
                        label={name}
                        fontSize='15px'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='400'
                        color='#ffffff'
                        bg='#1B1A1AB2'
                        hasArrow
                        placement='top'
                    >
                        <Text
                            style={{ fontFamily: 'Mulish, sans-serif' }}
                            fontWeight='700'
                            fontSize={['14px', '14px', '16px', '16px']}
                            color='#333333'
                            whiteSpace='nowrap'
                            overflow='hidden'
                            textOverflow='ellipsis'
                            cursor='pointer'
                            w='18ch'
                        >
                            {name ? name : 'Live Course Name'}
                        </Text>
                    </Tooltip>
                </Box>
            </Box>

            <Box d='flex' width='20%' justifyContent='center' alignItems='center'>
                <Text style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize={['14px', '14px', '16px', '16px']} color='#00000080' >{trainer_name}</Text>
            </Box>

            <Box d='flex' width='20%' justifyContent='center' alignItems='center'>
                <Text style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize={['14px', '14px', '16px', '16px']} color='#00000080' >{start_time}</Text>
            </Box>
            <Box d='flex' width='10%' justifyContent='center' alignItems='center'>
                <Circle bg='#429fff' size={['22px', '25px', '25px', '40px']} border='1px solid white' color='white' style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize={['7px', '10px', '11px', '15px']}>
                    {duration}
                </Circle>
            </Box>

            <Box d='flex' width='15%' justifyContent='center' alignItems='center'>
                <Link href={link} style={{ textDecoration: 'none' }} target='_blank'>
                    <Button
                        as={Button}
                        bgColor='#429fff'
                        color='white'
                        variant='outline'
                        p={['0.5rem', '0.5rem', '0.5rem', '0.75rem']}
                        size={['xs', 'sm', 'sm', 'md']}
                        fontWeight='700'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        borderRadius='lg'
                        fontSize={['7px', '10px', '11px', '15px']}
                        _hover={{ bg: "#3b8fe4" }}
                    >
                        Start Session
                    </Button>
                </Link>
            </Box>
            <Menu>
                <MenuButton
                    as={IconButton}
                    border='2px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    icon={<ContextMenuIcon />}
                    bg='white'
                    _hover={{ bg: "#f8f8f8" }}
                    _active={{ bg: "#f8f8f8" }}
                    position='static'
                    size={['xs', 'sm', 'sm', 'lg']}
                    p='0.5rem 1rem'
                />
                <MenuList style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize='14px' color='#00000099' minW='0' w='150px' position='relative' zIndex='10' >
                    <MenuItem>Delete</MenuItem>
                </MenuList>
            </Menu>
        </Box>
    )
}